export default "__VITE_ASSET__Dg2EUmS0__"